export type Feedback = {
  descriptionMain: string;
  descriptionSlave: string;
  userName: string;
  userCompany: string;
  companyImage: string;
};

export const FEEDBACKS: Feedback[] = [
  {
    descriptionMain:
      'Working with Green Line Logistics has been incredibly efficient and stress-free. Their dedication to maintaining capacity in key areas, along with their dependable team and solo trucks, ensures we never face delays.',
    descriptionSlave:
      'Their transparency and willingness to collaborate directly with our team to plan ahead have significantly enhanced our service quality. We truly appreciate their professionalism and proactive approach.',
    userName: 'Cameron Jolley',
    userCompany: 'Priority One',
    companyImage: '/images/priority-one.png',
  },
  {
    descriptionMain:
      'Green Line Logistics has been a partner we can truly trust for reliable and consistent service. Their quick response times and ability to provide on-time pickups and deliveries have been instrumental in meeting our tight schedules.',
    descriptionSlave:
      'With tracking powered by Samsara and excellent after-hours support, they keep us informed and confident every step of the way. Their flexibility and readiness to adapt have made them a key part of our operations.',
    userName: 'Nathan Wright',
    userCompany: 'Arrive Logistics',
    companyImage: '/images/arrive-logistics.png',
  },
  {
    descriptionMain:
      'Green Line Logistics’ expertise in handling temperature-sensitive shipments has made them an invaluable partner for us. Their attention to detail and consistent reliability make them a trusted partner for our most critical shipments.',
    descriptionSlave:
      'Their commitment to quality, paired with their 90% food-grade trailer availability and precise tracking through Samsara, ensures our products arrive exactly as required.',
    userName: 'Esteban Munar',
    userCompany: 'NFI Industries',
    companyImage: '/images/nfi-logo.png',
  },
  {
    descriptionMain:
      'Green Line Logistics has proven to be flexible and dependable, consistently delivering exceptional transportation solutions. Their ability to adapt to our specific requirements and ensure seamless pickups and deliveries in key locations has been a game-changer. ',
    descriptionSlave:
      'With multiple communication channels and their readiness to respond to updates quickly, they’ve shown a strong commitment to providing excellent service.',
    userName: 'Julian Lambert',
    userCompany: 'Traffic Tech',
    companyImage: '/images/traffictech-logo.png',
  },
];
